import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { fetchDataByOdata } from "./LpptestCrud";
import { getUserFactoryId, getUserId } from '../../../../index';
/**
 * 
 */
export const featchLpptestList = createAsyncThunk (
    'lpp/featchLpptestList',
    /**
     * 
     * @param {any} param01
     * @returns 
     */
    async (arg, { rejectWithValue, getState }) => {
        const { pagination, filters } = getState().lpptest
        let filter = {
            or: [
                { 'structure/factoryId': { eq: parseInt(getUserFactoryId()) } },
                { 'structure/factoryId': { eq: 1207 } },
            ],
            status: 'Official',
            version: { gt: 0 },
        }

        if (_.has(filters, 'structureId') && !_.isEmpty(filters.structureId)) {
            filter = _.merge(filter, {
                structureId: {
                    in: _.get(filters, 'structureId')
                }
            })
        }


        switch (filters.applicableToNewColleague)
        {
            case "Todos":
                delete filter.applicableToNewColleague;
                break;
            case "Sim":
                filter.applicableToNewColleague = true
                console.log("teste")
                break;
            case "Nao":
                filter.applicableToNewColleague = false
                break;
        }

        switch (filters.training)
        {
            case "Todos":
                delete filter.TrainingUsers;
                break;
            case "pending":
                filter = _.merge(filter, {
                    TrainingUsers: {
                        any: {
                            UserId: getUserId(),
                            status : false
                        }

                    }
                })
                break; 
            case "concluded":
                filter = _.merge(filter, {
                    TrainingUsers: {
                        any: {
                            UserId: getUserId(),
                            status: true
                        }

                    }
                })
                break;         
        }

        switch (filters.classification)
        {
            case "Todos":
                delete filter.classification;
                break;
            default:
                filter.classification = filters.classification;
                break;         
        }

        switch (filters.pilar)
        {
            case "Todos":
                delete filter.pilar;
                break;
            default:
                filter.pilar = filters.pilar
                break;
        }
        
        if (!_.isEmpty(filters.identifier)) {
            filter.identifier = filters.identifier
        }

        if (!_.isEmpty(filters.name)) {
            filter.name = filters.name
        }

        //autor
        if (!_.isEmpty(filters.user)) {
            filter.user={name:filters.user}
        }    

        // Date fim
        if (filters.endDate != null) {
            filter = _.merge(filter, {
                createdAt: { le: filters.endDate }
            })
        }

        // Date inicio
        if (filters.startDate != null) {
            filter = _.merge(filter, {
                createdAt: { ge: filters.startDate }
            })
        }

        let expand = {
            TrainingUsers: {
                filter: {
                    UserId: getUserId()
                },
                select: ['status']
            },
            structure: { 
                select: ['name'],
                expand: {
                    factory: { select: ['name'] }
                }
            },
            user: { select: ['name'] }
        }

        const res = await fetchDataByOdata({
            filter,
            top: pagination.sizePerPage,
            skip: (pagination.page - 1) * pagination.sizePerPage,
            count: true,
            orderBy: ['CreatedAt desc'],
            expand
        })

        if ( res.status !== 200 ) {
            rejectWithValue(res.statusText)
        }

        return {
            entities: res.data.value,
            total: res.data._count
        };
    }
)